"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotarizationProvider = void 0;
var NotarizationProvider;
(function (NotarizationProvider) {
    NotarizationProvider["AVEN"] = "AVEN";
    NotarizationProvider["SERVICE_LINK"] = "SERVICE_LINK";
    NotarizationProvider["PERSONAL_ATTORNEY"] = "PERSONAL_ATTORNEY";
    NotarizationProvider["SETTLEMENT_AGENT"] = "SETTLEMENT_AGENT";
})(NotarizationProvider || (exports.NotarizationProvider = NotarizationProvider = {}));
